import { httpsCallable } from 'firebase/functions';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db, functions } from '../firebase';
import { lyricsHash } from './songSectionsModel';

/**
 * Ask the server to label a song's sections (functions/songSections.js).
 * `force` re-detects even over a teacher's edits — the "Detect again" button.
 * Resolves { sections, sectionsMeta, kept }.
 */
export const labelSongSections = async (repertoireId, { force = false } = {}) => {
	// The function allows 120s (Opus thinks first); the client default is 70s.
	const res = await httpsCallable(functions, 'labelSongSections', { timeout: 130000 })({ repertoireId, force });
	return res.data;
};

/**
 * A teacher's rename, saved straight to the repertoire row (staff may update
 * it). Marked 'edited' against the CURRENT lyrics hash, so a later re-open
 * keeps it and only a lyrics change or "Detect again" replaces it.
 */
export const saveEditedSections = async (repertoireId, sections, lyricsText) => {
	const sectionsMeta = { source: 'edited', lyricsHash: lyricsHash(lyricsText), at: serverTimestamp() };
	await updateDoc(doc(db, 'repertoire', repertoireId), { sections, sectionsMeta, updatedAt: serverTimestamp() });
	return { sections, sectionsMeta: { ...sectionsMeta, at: new Date() } };
};
